export default __webpack_public_path__ + "static/media/BannerImage.ee9e3eb9.jpeg";